var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.initialized)?_c('app-loading'):_vm._e(),(_vm.appLoaded)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }